import type { AxiosInstance } from "axios";
import type { InjectionKey } from "vue";

/**
 * Diferente dos outros apps do monorepo, aqui não há um `api` singleton
 * criado no import (o tenantSlug só é conhecido depois da descoberta por
 * e-mail — ver main.ts). O cliente HTTP é criado no bootstrap e injetado via
 * provide/inject (mesmo padrão de `@inbim/cadastro-pages` `CADASTRO_API_KEY`).
 */
export const API_KEY: InjectionKey<AxiosInstance> = Symbol("assinatura-app-api");
